"use client";

import { motion } from "motion/react";
import { ShieldCheck } from "iconoir-react";

interface AdminOrgBannerProps {
  /** Name of the org this create flow was launched for, from admin-dash's "Create event" button. */
  orgName: string;
}

/**
 * Persistent notice shown across every step of the wizard when a Nowadays admin launched `/create`
 * from an org's admin-dash page (ENG-918), so it's never ambiguous whose event is being created —
 * this deliberately doesn't auto-dismiss or move, unlike {@link ResumeDraftBanner}, since the
 * "who is this for" context stays relevant for the whole fill, not just the first render.
 */
export const AdminOrgBanner = ({ orgName }: AdminOrgBannerProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="flex items-center gap-3 rounded-2xl bg-amber-50 px-4 py-3 text-left ring-1 ring-inset ring-amber-200"
      role="status"
    >
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white text-amber-600">
        <ShieldCheck className="h-4 w-4" strokeWidth={2} aria-hidden="true" />
      </span>
      <p className="text-sm font-semibold text-gray-900 tracking-tight">
        Admin: launched for <span className="font-semibold">{orgName}</span>
      </p>
    </motion.div>
  );
};
